import { isValidEmailAddress, fadeOutNotifications } from '../functions';

$(document).ready(function() {

	const autoDealers = {
        isLoading: false,
        init() {
            $(document).on('click', '.auto-dealer-model-category', this, this.showModels);
        },
		showModels(event) {
			const _this = event.data;

			let id = $(this).data('id');
			if (!id || id == '' || id == null) {
				console.error('Invalid ID!');
				return false;
			}

			$('.auto-dealer-model-category').parent().removeClass('active');
			$(this).parent().addClass('active');

			$(".audo-dealer-model-item").not(".adc-model-" + id).hide();
			$(".adc-model-" + id).show();
		}
    };

    if ($('.auto-dealers-container').length) {
        autoDealers.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/auto-dealers.js